/* eslint-disable no-underscore-dangle */

import React, { useState } from "react";
import { Session } from "/imports/client/client-session";
import { Grid, Button } from "semantic-ui-react";
import { AutoForm, AutoField, ErrorsField } from "uniforms-semantic";
import { useMutation } from "@apollo/client";
import { LOGIN_WITH_PASSWORD_MUTATION } from "./queries";
import hashPassword from "/imports/api/accounts/utils/hash-password";
import { clearSessionData, setSessionLoginData } from "/imports/api/accounts/client/user-session";
import client from "/imports/client/services/apollo/client"; // root -> required.
import { cleanUpAndValidateEmail } from "/imports/utils/functions/fnCleanupEmail";
import { RegEx } from "/imports/api/_jsonSchemas/schemas/components/_all";
import { initJSONschema } from "/imports/utils/UI/initJSONschema";
import useRoute from "../../router/useRoute";

import Debug from "debug";
const debug = Debug("routes:signin");

const schema = initJSONschema({
  type: "object",
  properties: {
    email: {
      type: "string",
      pattern: RegEx.Email.source // returns string without /
    },
    password: {type: "string"}
  },
  required: ["email", "password"],
  errorMessage:{
    properties: {
      email: "Email should be a valid email address",
      password: "Password is required"
    }
  }
});

const SignIn = () => {
  debug("call sign in");
  const [loggingIn, setloggingIn] = useState(false);
  const [error, setError] = useState();
  const { goRoute, goRoutePath } = useRoute();
  const [loginWithPassword] = useMutation(LOGIN_WITH_PASSWORD_MUTATION);

  const submitForm = async (data) => {
    setloggingIn(true);
    clearSessionData();

    try {
      await client.clearStore();
    } catch (err) {
      // do nothing
    }

    const { email, password } = data;

    const {
      data: { loginWithPassword: loginWithPasswordData },
      error
    } = await loginWithPassword({
      variables: {
        input: {
          email: cleanUpAndValidateEmail(email),
          hashedPassword: hashPassword(password)
        }
      }
    });

    if (error || !loginWithPasswordData) {
      setloggingIn(false);
      setError(new Error("Wrong login/password combination"));
    }

    const { userId, token, user } = loginWithPasswordData;

    setSessionLoginData({ token, userId, user });

    const loginRedirect = Session.get("loginRedirect");
    if (loginRedirect) {
      Session.set("loginRedirect", false);
      return goRoutePath(loginRedirect);
    }

    return goRoute("dashboard");
  };

  return (
    <AutoForm
      className="ui inverted form sign-in"
      schema={schema}
      onSubmit={submitForm}
      onChange={() => {
        setError();
      }}
      error={error}
    >
     
      <img className="ui medium image logo" src="/images/logo-transmate.svg" alt="logo" />
      <div style={{color:'black !important'}}>
        <AutoField name="email" label="Email" type="email" autoComplete="username" id="email" />
      </div>
      <AutoField name="password" label="Password" type="password" autoComplete="current-password" id="password" />
      <Grid columns={2}>
        <Grid.Column>
          {loggingIn ? (
            <Button primary disabled content="Signing in..." />
          ) : (
            <Button type="submit" primary content="Sign in" id="signin" />
          )}
        </Grid.Column>
        <Grid.Column>
          <a id="forgot" href="/forgot-password">Forgot your password?</a>
        </Grid.Column>
      </Grid>
     
      <small>
        No account yet?
        <a href="/register" id="register" data-test="register">
          Create one for free.
        </a>
      </small>
      <ErrorsField />
    </AutoForm>
  );
};

export default SignIn;
